module.exports = __webpack_public_path__ + "img/materialMechanics.57a1902d.jpg";